// onUpdateRegistration.ts
//TODO consolidate subscription defs into one file 
import { gql } from '@apollo/client';
import { onUpdateRegistration } from '../subscriptions';

export const ON_UPDATE_REGISTRATION = gql`${onUpdateRegistration}`;